import { track } from "@amplitude/analytics-react-native";
import { amp } from "src/api/amplitude";
import ToggleBadge from "src/components/ToggleBadge";
import Touchable from "src/components/Touchable";
import { useGatheringStore } from "src/contexts/GatheringContext";
import { UseGatheringAndUsers_User } from "src/hooks/useGatheringAndUsers";
import IconFilter from "src/icons/IconFilter";

const GatheringViewerFilterToggle = ({ user }: { user: UseGatheringAndUsers_User }) => {
	const isSelected = useGatheringStore((state) => state.filterUserIds.includes(user.userId));
	const toggleFilterUserId = useGatheringStore((state) => state.toggleFilterUserId);

	return (
		<Touchable
			onPress={() => {
				track(amp.gathering.otherUserFilterToggle, {
					wasSelected: isSelected,
				});
				toggleFilterUserId(user.userId);
			}}
		>
			<ToggleBadge isSelected={isSelected} Icon={IconFilter} />
		</Touchable>
	);
};
export default GatheringViewerFilterToggle;
